import { type MapSettingsDataAction } from '../../data/mapSettingsData.action';
import { type ExportPdfToolStateAction } from './exportPdfToolState.action';
import {
  exportPdfDisable, exportPdfEnable,
} from './exportPdfToolState.actionCreators';
import { type ExportPdfToolState } from './exportPdfToolState.state';

export const mapSettingsExportPdfInitialState: ExportPdfToolState = {
  isActive: false,
  params: null,
};

export const exportPdfToolStateReducer = (
  state = mapSettingsExportPdfInitialState,
  action: ExportPdfToolStateAction | MapSettingsDataAction
): ExportPdfToolState => {
  if (exportPdfEnable.match(action)) {
    return {
      isActive: true,
      params: action.payload.params,
    };
  }

  if (exportPdfDisable.match(action)) {
    return {
      isActive: false,
      params: null,
    };
  }

  return state;
};
